import "@/index.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import LatestFindings from "@/components/LatestFindings";
import ModelExplorer from "@/components/ModelExplorer";
import HowItWorks from "@/components/HowItWorks";
import GetStarted from "@/components/GetStarted";
import BlogFeed from "@/components/BlogFeed";
import CiteBlock from "@/components/CiteBlock";
import Resources from "@/components/Resources";
import Footer from "@/components/Footer";
import { ResultsProvider } from "@/data/ResultsContext";

function App() {
  return (
    <ResultsProvider>
    <div className="min-h-screen bg-[#0A0A0A] text-neutral-100 grain">
      <Navbar />
      <main>
        <Hero />
        <About />
        <LatestFindings />
        <ModelExplorer />
        <HowItWorks />
        <GetStarted />
        <BlogFeed />
        <CiteBlock />
        <Resources />
      </main>
      <Footer />
    </div>
    </ResultsProvider>
  );
}

export default App;
